import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@shared/config';

const APP_VERSION_HEADER = 'OD-App-Version';

export const appVersionInterceptor: HttpInterceptorFn = (req, next) => {
  const appVersion = inject(APP_CONFIG).version;
  const versionReq = req.clone({
    headers: req.headers.set(APP_VERSION_HEADER, appVersion),
  });

  return next(versionReq);
};
